import React from "react";

export const ContactInfo = ({ consignment }) => {
    const subject = `ASN Enquiry Re. Consignment# ${consignment.connoteNumber}`;
    const mailto = `mailto:support@freightpeople.com.au?subject=${subject}`;
    return (
        <div className="text-center">
            <p className="h3 font-weight-bold text-white mb-4">Got questions? Contact us!</p>
            <a id="email-enquiry" href={mailto} className="btn btn-primary btn-lg px-5 py-3">
                email enquiry
            </a>
        </div>
    );
};
